export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./how-work-with-leads.vue?vue&type=template&id=153ef348&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/how-work-with-leads.vue?vue&type=template&id=153ef348&
// module id = 1717
// module chunks = 0